import { render, staticRenderFns } from "./batchDetail.vue?vue&type=template&id=ab566fd6&scoped=true&"
import script from "./batchDetail.vue?vue&type=script&lang=js&"
export * from "./batchDetail.vue?vue&type=script&lang=js&"
import style0 from "./batchDetail.vue?vue&type=style&index=0&id=ab566fd6&lang=less&scoped=true&"
import style1 from "./batchDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab566fd6",
  null
  
)

export default component.exports